// extracted by mini-css-extract-plugin
export default {"container":"TermAddField_container__eBd3N","topContainer":"TermAddField_topContainer__eng9p"};